export default __webpack_public_path__ + "static/media/raf2.7aa60102.svg";